import React from 'react';
import { DotLottiePlayer } from '@dotlottie/react-player';
import '@dotlottie/react-player/dist/index.css';
import { alpha } from '@mentimeter/ragnar-colors';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';
import { NumberCounter } from './NumberCounter';
import { OPEN_ENDED_VOTING__LOADING_ANIMATION_URL } from './constants';
import { OpenEndedTitleDataHandler } from './ui/OpenEndedTitleDataHandler';

export interface StartVotingViewProps {
  numberOfVoters: number;
}

export const StartVotingView = ({ numberOfVoters }: StartVotingViewProps) => {
  const translate = useTranslations('presenting.legacy');
  const shouldShowNumberOfVoters = numberOfVoters > 0;

  const counterText =
    numberOfVoters === 1
      ? translate('open.one_person_voted')
      : translate('open.x_people_voted');

  return (
    <Box
      width="100%"
      height="100%"
      alignItems="flex-start"
      flexDirection="column"
      justifyContent="flex-start"
      data-testid="presentation-container"
    >
      <OpenEndedTitleDataHandler mb={0} />
      <Box flexDirection="column" justifyContent="flex-start" mb="40px"></Box>
      <Box alignItems="center" width="100%">
        <Box
          alignItems="center"
          borderRadius="64px"
          pt="48px"
          pb="72px"
          px="90px"
          extend={({ theme }) => ({
            background: alpha(theme.colors.neutralWeakest, 0.75),
          })}
        >
          <Box width="400px">
            <DotLottiePlayer
              src={OPEN_ENDED_VOTING__LOADING_ANIMATION_URL}
              autoplay
              loop
            />
          </Box>
          <Text fontSize={5} color="text" mt={4}>
            {shouldShowNumberOfVoters ? (
              <Box flexDirection="row" alignItems="baseline">
                <NumberCounter value={numberOfVoters} />
                <Text
                  color="text"
                  fontFamily="heading"
                  lineHeight="none"
                  fontSize={3}
                >
                  {counterText}
                </Text>
              </Box>
            ) : (
              translate('open.voting_in_progress_label')
            )}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
